import { ActivityOwner } from '../../../../core/entities/activity/activity-owner';
import { File } from '../../../../core/entities/file/file';
import { CommandTemplate } from '../../../../core/entities/commandTemplate/commandTemplate';
import { HasCommands } from '../../../../core/services/command/command.service';
import { LocationEntity } from "src/app/shared-module/shared/entities/location/location";
import { Contact } from "../../../../rent-module/shared/entities/contact/contact";
import { ContactPerson, ContactPersonInput } from "../../../../rent-module/shared/entities/contactPerson/contactPerson";
import { LineItem } from "../../../../rent-module/shared/entities/lineItem/lineItem";
import { Comment } from "../comment/comment";
import { CustomAttributeSectionViewModel } from "../customAttributeSectionViewModel/customAttributeSectionViewModel";
import { PrimeNGSeverity } from "../../../../shared-module/shared/types/primeng-severity.type";

export class Order implements HasCommands, ActivityOwner{

  static ENTITY_TYPE: string = 'Order';

  id: string | undefined;
  externalId: string | undefined;
  number: string;
  lineItems: LineItem[];
  customer: Contact;
  type: OrderType;
  state: OrderState;
  customAttributes: any[];
  schedulingInformation: any;
  isDeletable: boolean;
  orderer: ContactPerson;
  note: string;
  customerOrderNumber: string;
  location: LocationEntity;
  archive: boolean;
  comments: Comment[];
  files: File[];
  fileCount: any;
  commentCount: any;
  noteCount: any;
  timeEntriesCount: any;
  commands: CommandTemplate[];
  customAttributeSectionsViewModel: CustomAttributeSectionViewModel[];
  aggregationRootId: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.number = payload.number;
      // console.log('test');
      if(payload.lineItems && payload.lineItems.length > 0){
        this.lineItems = new Array<LineItem>();
        payload.lineItems.map( (lineItem: any) => {
          this.lineItems.push(new LineItem(lineItem));
        })
      }
      this.type = payload.type;
      this.state = payload.state;
      this.customAttributes = payload.customAttributes;
      this.isDeletable = payload.isDeletable;
      this.customerOrderNumber = payload.customerOrderNumber;
      this.note = payload.note;
      this.schedulingInformation = payload?.schedulingInformation
      this.archive = payload?.archive;
    }
    if (payload.customer) {
      this.customer = new Contact(payload.customer);
    }
    if (payload.orderer) {
      this.orderer = new ContactPerson(payload.orderer);
    }
    if (payload?.lineItems) {
      this.lineItems = LineItem.createLineItems(payload.lineItems);
    }
    if (payload.location) {
      this.location = new LocationEntity(payload.location);
    }
    if (payload?.comments) {
      this.comments = Comment.createComments(payload.comments);
    }
    if (payload?.files) {
      this.files = payload.files;
    }
    if(payload.commands){
      this.commands = new Array<CommandTemplate>();
      payload.commands.map( (command: any) => {
        this.commands.push(new CommandTemplate(command));
      })
    }
    this.fileCount = payload?.fileCount;
    this.commentCount = payload?.commentCount;
    this.noteCount = payload?.noteCount;
    this.timeEntriesCount = payload?.timeEntriesCount;
    if (payload.customAttributeSectionsViewModel) {
      this.customAttributeSectionsViewModel = CustomAttributeSectionViewModel.createCustomAttributeSectionViewModels(payload.customAttributeSectionsViewModel);
    }
    this.aggregationRootId = payload?.aggregationRootId;
  }
  entityType: string = Order.ENTITY_TYPE;

  getEntityType(): string {
    return Order.ENTITY_TYPE;
  }

  getCollectionRoute(): string {
    return '/orders';
  }

  getEntityId(): string {
    return this.id || undefined;
  }

  /**
   * creates models from a result
   * @param result Array of any
   * @returns Bookigs
   */
  static createOrders(result: Array<any>): Order[] {
    const orders = new Array<Order>();
    if (result) {
      result?.map((order) => {
        orders.push(new Order(order));
      });
    }
    return orders;
  }
  static getOrderType(type: string): string {
    switch (type) {
      case 'RENTAL':
        return 'orderModule.order.type.rental';
      case 'OPERATED_RENTAL':
        return 'orderModule.order.type.operatedRental';
      default:
        return '';
    }
  }

  static getOrderTypes(): any[] {
    const orderTypes: { id: string; name: string, label: string }[] = [];
    orderTypes.push(
      {
        id: 'RENTAL',
        name: 'orderModule.order.type.rental',
        label: 'orderModule.order.type.rental',
      },
      {
        id: 'OPERATED_RENTAL',
        name: 'orderModule.order.type.operatedRental',
        label: 'orderModule.order.type.operatedRental',
      }
    );
    return orderTypes;
  }

  static getOrderState(state: string): string {
    switch (state) {
      case 'NEW':
        return 'orderModule.order.state.new';
      case 'RUNNING':
        return 'orderModule.order.state.running';
      case 'COMPLETED':
        return 'orderModule.order.state.completed';
      case 'ARCHIVED':
        return 'orderModule.order.state.archived';
      default:
        return '';
    }
  }

  public getOrderStateSeverity(): PrimeNGSeverity | undefined {
    return Order.getOrderStateSeverityStatic(this.state + '');
  }

  static getOrderStateSeverityStatic(state: string): PrimeNGSeverity | undefined {
    switch (state) {
      case 'NEW':
        return 'info';
      case 'RUNNING':
        return 'warning';
      case 'COMPLETED':
        return 'success';
      case 'ARCHIVED':
        return 'info';
      default:
        return undefined;
    }
  }

  static getOrderStates(): any[] {
    const orderStates: { id: string; name: string, label: string }[] = [];
    orderStates.push(
      {
        id: 'NEW',
        name: 'orderModule.order.state.new',
        label: 'orderModule.order.state.new',
      },
      {
        id: 'RUNNING',
        name: 'orderModule.order.state.running',
        label: 'orderModule.order.state.running',
      },
      {
        id: 'COMPLETED',
        name: 'orderModule.order.state.completed',
        label: 'orderModule.order.state.completed',
      },
      {
        id: 'ARCHIVED',
        name: 'orderModule.order.state.archived',
        label: 'orderModule.order.state.archived',
      }
    );
    return orderStates;
  }

  static getOrderIcon(type: string): string {
    switch (type) {
      case 'RENTAL':
        return 'icon icon-rental';
      case 'OPERATED_RENTAL':
        return 'icon icon-control';
      case 'SERVICE':
        return 'icon icon-task';
      case 'DELIVERY':
        return 'icon icon-deliver';
      default:
        return '';
    }
  }

}


export class OrderInput {
  id: string;
  externalId: string;
  type: OrderType;
  number: string;
  lineItems: any[];
  orderer: ContactPersonInput;
  customerOrderNumber: string;
  note: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.type = payload.type;
      this.number = payload.number;
      this.lineItems = payload.lineItems;
      this.orderer = payload.orderer;
      this.customerOrderNumber = payload.customerOrderNumber;
      this.note = payload.note;
    }
  }
}

export enum OrderState {
	NEW,
  RUNNING,
  COMPLETED,
  ARCHIVED
}

export enum OrderType {
  RENTAL
}
